module.exports = __webpack_public_path__ + "static/media/working.a8ef4178.jpg";